import "@fontsource/atkinson-hyperlegible";
import hljs from 'highlight.js';
import 'highlight.js/styles/tokyo-night-dark.min.css';

hljs.highlightAll();
